import { createContext } from "react";
export const ProgramContext = createContext();
export const SettingsContext = createContext();
